<template>
  <section>
    <v-card>
      <v-card-text class="pa-0">
        <v-data-table
          class="elevation-1 tabla-comprimida-light"
          :headers="headers_saldos"
          :items="l_saldos_vacaciones"
          hide-actions
        >
          <template v-slot:items="props">
            <td class="text-xs-center">
              {{ `${props.item.gestion_desde} - ${props.item.gestion_hasta}` }}
            </td>
            <td class="text-xs-center">{{ props.item.dias_asignados }}</td>
            <td class="text-xs-center">{{ props.item.dias_utilizados }}</td>
            <td class="text-xs-center">{{ props.item.dias_restantes }}</td>
            <td class="text-xs-center">
              <v-chip
                dark
                :color="
                  props.item.tipo_gestion == 'A GANAR'
                    ? 'indigo'
                    : props.item.tipo_gestion == 'VIGENTE'
                    ? 'success'
                    : 'red'
                "
              >
                {{ props.item.tipo_gestion }}
              </v-chip>
            </td>
            <td class="text-xs-center font-weight-bold">
              {{ props.item.rango_salida }}
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
export default {
  props: {
    id_estado_vacacion: {
      type: Number,
      default: null
    },
    id_persona: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      user: this.$storage.get("user"),
      estado_vacacion: null,
      datos_programacion: null,
      datos_personales: null,
      l_saldos_vacaciones: [],
      headers_saldos: [],
      api_backend: process.env.API_URL.split("api/")[0],
      foto: "",
      atributos_persona: []
    };
  },
  computed: {},
  async mounted() {
    // Obtenemos datos de saldos de vacaciones
    this.l_saldos_vacaciones = await this.$query.select(
      "v_saldos_vacacion",
      { id_persona: this.user.id_persona },
      [
        "id_estado_vacacion",
        "periodo",
        "gestion_desde",
        "gestion_hasta",
        "dias_asignados",
        "dias_utilizados",
        "dias_restantes",
        "fecha_incorporacion",
        "tipo_gestion",
        "rango_salida"
      ]
    );
    // Constuimos headers
    this.headers_saldos = [
      { text: "Gestión", value: "periodo", align: "center", sortable: true },
      {
        text: "Días asignados",
        value: "",
        align: "center",
        sortable: false
      },
      {
        text: `Días utilizados`,
        value: "",
        align: "center",
        sortable: false
      },
      {
        text: "Dias saldo",
        value: "",
        align: "center",
        sortable: false
      },
      {
        text: "Estado",
        value: "",
        align: "center",
        sortable: false
      },
      {
        text: "Nota a considerar",
        value: "",
        align: "center",
        sortable: false
      }
    ];
  },
  methods: {}
};
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/admin/vacaciones/components/HistoricoPeriodosVacacion.vue